module.exports = __webpack_public_path__ + "2797541de725602302eef1fe90352393.svg";